<template>
  <div class="cashier-container" :class="{ 'keyboard-active': showNumberKeyboard && isPC }">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="back-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="title">收银台</div>
      <div class="placeholder"></div>
    </div>

    <!-- 商户信息 -->
    <div class="merchant-info">
      <div class="merchant-name">{{ merchantInfo.name }}</div>
    </div>

    <!-- 金额部分 -->
    <div class="amount-section">
      <div class="amount-row">
        <div class="amount-label">金额：<span class="currency">¥</span></div>
        <div class="amount-input-wrapper">
          <!-- 修改部分：使用div显示金额，点击打开数字键盘 -->
          <div 
            class="amount-display"
            :class="{ 'disabled': hasUrlAmount }"
            @click="!hasUrlAmount && (showNumberKeyboard = true)"
          >
            {{ inputAmount || '0' }}
          </div>
        </div>
      </div>
    </div>

    <!-- 支付方式 -->
    <div class="payment-method">
      <div 
        v-for="method in paymentMethods" 
        :key="method.id"
        class="payment-item"
        :class="{ selected: selectedPaymentMethod === method.id }"
        @click="selectPaymentMethod(method.id)"
      >
        <div class="payment-info">
          <img class="payment-icon" :src="method.icon" :alt="method.name" />
          <span class="payment-name">{{ method.name }}</span>
        </div>
        <div class="payment-radio">
          <div v-if="selectedPaymentMethod === method.id" class="radio-checked"></div>
        </div>
      </div>
    </div>

    <!-- 购买者姓名 -->
    <div class="remark-section" v-if="buyerNameisRequired">
      <div class="remark-row">
        <div class="remark-label">购买者姓名：</div>
        <input 
          type="text" 
          class="remark-input"
          v-model="buyerName" 
          placeholder="请输入购买者姓名"
        >
      </div>
      <div class="name-note">名称起查账口令作用，乱写容易导致充值错误，损失自行承担</div>
    </div>

    <!-- 新增错误提示 -->
    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    
    <!-- 修改按钮的 disabled 属性，并绑定点击事件 -->
    <button 
      @click="submitAmount" 
      class="submit-button"
      :disabled="isSubmitting"
    >
      {{ isSubmitting ? '提交中...' : '确定' }}
    </button>

    <!-- Vant数字键盘 -->
    <van-number-keyboard
      v-if="!hasUrlAmount"
      :show="showNumberKeyboard"
      :maxlength="3"
      @input="onNumberInput"
      @delete="onNumberDelete"
      @close="showNumberKeyboard = false"
      show-delete-key
      close-button-text="完成"
      theme="custom"
    />
  </div>
</template>

<script>
import axios from 'axios';
import md5 from 'js-md5';
// 引入Vant数字键盘组件
import { NumberKeyboard } from 'vant';

export default {
  components: {
    [NumberKeyboard.name]: NumberKeyboard
  },
  data() {
    return {
      inputAmount: '',
      isGameIdTwo: false,
      isGameIdOne: false,
      gameid: null,
      id: null,
      urlAmount: null,
      payChannelId:null,
      buyerName: '', 
      buyerNameisRequired: false,//用户名是否必填 
      // 新增错误提示信息变量
      errorMessage: '',
      // 新增提交状态
      isSubmitting: false,
      merchantInfo:{
        name:'请输入金额',
        avatar:'https://img01.yzcdn.cn/vant/cat.jpeg'
      },
      // 新增支付方式数据
      paymentMethods: [
        {
          id: 'alipay',
          name: '支付宝',
          icon: require('../assets/alpay-icon.png')
        }
      ],
      selectedPaymentMethod: 'alipay', // 默认选择支付宝
      // 数字键盘相关
      showNumberKeyboard: true,
      // 新增URL金额判断
      hasUrlAmount: false,
      // 判断是否为PC端
      isPC: false
    };
  },
  watch: {
    // 监听键盘显示状态
    showNumberKeyboard() {
      // 最简单的PC端判断：不是移动设备就是PC端
      this.isPC = !/Mobi|Android/i.test(navigator.userAgent);
    }
  },
  async mounted() {
    // 最简单的PC端判断
    this.isPC = !/Mobi|Android/i.test(navigator.userAgent);
    
    // 动态设置body样式
    document.body.style.margin = '0 auto';
    
    const urlParams = new URLSearchParams(window.location.search);
    this.gameid = urlParams.get('gameid');
    this.id = urlParams.get('id');
    this.urlAmount = urlParams.get('amount');
    this.payChannelId = urlParams.get('paychannelid');

    // 修改部分：将判断条件从 gameid === '2' 改为 gameid 等于 '2' 或 '3'
    if (this.gameid === '2' || this.gameid === '3') {
      this.isGameIdTwo = true;
      if (this.urlAmount && parseInt(this.urlAmount) > 0) {
        this.inputAmount = this.urlAmount;
        this.isGameIdOne = true; 
        this.hasUrlAmount = true; // 设置URL金额标志
      } 
    } else if (this.gameid === '1' && this.urlAmount) {
      this.inputAmount = this.urlAmount;
      this.isGameIdOne = true;
      this.hasUrlAmount = true; // 设置URL金额标志
    }
  },
  beforeDestroy() {
    // 清理body样式
    document.body.style.margin = '';
  },
  methods: {
    // 数字键盘输入
    onNumberInput(value) {
      if (this.isGameIdOne || this.hasUrlAmount) return; // 如果金额被锁定或有URL金额，不允许修改
      
      // 限制最大3位数
      if (this.inputAmount.length >= 4) return;
      
      this.inputAmount += value;
      this.validateInputAmount();
    },
    // 数字键盘删除
    onNumberDelete() {
      if (this.isGameIdOne || this.hasUrlAmount) return; // 如果金额被锁定或有URL金额，不允许修改
      
      this.inputAmount = this.inputAmount.slice(0, -1);
    },
    validateInputAmount() {
      if (this.inputAmount === '') {
        return;
      }
      let value = parseInt(this.inputAmount);
      if (isNaN(value) || value < 1) {
        this.inputAmount = '1';
      } else if (value > 1999) {
        this.inputAmount = '1999';
      }
    },
    selectPaymentMethod(methodId) {
      this.selectedPaymentMethod = methodId;
    },
    async submitAmount() {
      // 如果正在提交，直接返回
      if (this.isSubmitting) return;
      // 设置为正在提交状态
      this.isSubmitting = true;
      // 清空之前的错误信息
      this.errorMessage = '';
      // 检查 buyerName 是否为空
      if (!this.buyerName.trim() && this.buyerNameisRequired) {
        // 修改为页面显示错误提示
        this.errorMessage = '购买者姓名不能为空';
        // 恢复可点击状态
        this.isSubmitting = false;
        return;
      }
  
      // 验证金额必须为大于 0 小于 1000 的整数
      const amount = parseInt(this.inputAmount);
      if (this.gameid === '2' ) 
      {
        if (isNaN(amount) || amount <10 || amount >= 2000) {
        this.errorMessage = '金额必须为大于等于 10 小于 2000 的整数';
        // 恢复可点击状态
        this.isSubmitting = false;
        return;
        }
      }else
      {
          if (isNaN(amount) || amount <1 || amount >= 3001) {
          this.errorMessage = '金额必须为大于等于 1 小于等于 3000 的整数';
          // 恢复可点击状态
          this.isSubmitting = false;
          return;
        }

      }


  
      try {
        const key = process.env.VUE_APP_API_KEY;
        const timestamp = new Date().getTime();
        const token = md5(timestamp + key);
        if (!this.buyerName.trim() ) 
        {
          this.buyerName ='空';
        }
        // 判断是否为本机地址
        const originUrl= 'http://localhost:5053';
        const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);
        const PayUrl = isLocal 
            ? `${originUrl}/api2/Pay3` 
            : `${window.location.origin}/api2/Pay3`;
        const response = await axios.post(PayUrl, {
          amount: this.inputAmount,
          id: this.id,
          token: token,
          gameid: this.gameid,
          payChannelId: this.payChannelId,
          timestamp: timestamp,
          buyerName: this.buyerName, 
        });
        console.log('创建订单响应:', response.data);
        const payUrl = response.data.data.payurl;
        if (payUrl) {
          window.location.href = payUrl;
        } else {
          this.errorMessage = '未获取到有效的支付链接';
        }
      } catch (error) {
        this.errorMessage = '创建订单失败: ' + error.message;
      } finally {
        // 无论请求成功或失败，都恢复可点击状态
        this.isSubmitting = false;
      }
    }
  }
};
</script>


<style scoped>
:deep(.van-number-keyboard){
  max-width: 428px;
  left: 50%;
  transform: translateX(-50%);
}
.cashier-container {
  background: #f5f5f5;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

/* 顶部导航栏 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}

.back-icon, .placeholder {
  width: 24px;
  height: 24px;
}

.back-icon {
  cursor: pointer;
}

.title {
  font-size: 17px;
  font-weight: 600;
  color: #000;
  flex: 1;
  text-align: center;
}

/* 商户信息 */
.merchant-info {
  display: flex;
  align-items: center;
  padding: 20px 16px 0 16px;
  background: #fff;
}

.merchant-avatar {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  position: relative;
}

.merchant-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.merchant-name {
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

/* 金额部分 */
.amount-section {
  background: #fff;
  padding: 20px 16px 30px 16px;
  margin-bottom: 10px;
}

.amount-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #F8F8F8;
  padding: 10px 16px;
  border-radius: 8px;
}

.amount-label {
  font-size: 16px;
  color: #000;
  font-weight: 500;
  width: 100px;
  flex-shrink: 0;
  text-align: left;
}
.currency {
  color: #000;
  font-weight: 500;
  margin-right: 2px;
  font-size: 30px;
}

.amount-input-wrapper {
  display: inline-flex;
  align-items: center;
  font-size: 30px;
  margin-left: auto;
}

.amount-display {
  font-size: 30px;
  color: #000;
  background: transparent;
  font-weight: 500;
  text-align: right;
  padding: 8px 12px;
  margin: 0;
  min-width: 60px;
  cursor: pointer;
  border-bottom: 1px dashed #ccc;
}

.amount-display:hover {
  border-bottom-color: #3f9fff;
}

.amount-display.disabled {
  cursor: not-allowed;
  color: #000;
  border-bottom-color: #3f9fff;
}

/* 支付方式 */
.payment-method {
  background: #fff;
  padding: 16px;
  margin-bottom: 10px;
}

.payment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  cursor: pointer;
  border-radius: 8px;
  padding: 12px 8px;
  margin: 4px 0;
}

.payment-item:hover {
  background-color: #f0f0f0;
}

.payment-item.selected {
  background-color: #f0f8ff;
}

.payment-info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  
}

.payment-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}

.payment-name {
  font-size: 16px;
  color: #000;
}

.payment-radio {
  width: 18px;
  height: 18px;
  border: 2px solid #3f9fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.radio-checked {
  width: 10px;
  height: 10px;
  background: #3f9fff;
  border-radius: 50%;
}

/* 备注部分 */
.remark-section {
  background: #fff;
  padding: 16px;
  margin-bottom: 20px;
}

.remark-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.remark-label {
  font-size: 16px;
  color: #000;
  font-weight: 500;
  width: 100px;
  flex-shrink: 0;
  text-align: left;
}

.remark-input {
  border: none;
  outline: none;
  font-size: 16px;
  color: #000;
  background: transparent;
  padding: 8px 0;
  text-align: right;
  flex: 1;
}

.remark-input::placeholder {
  color: #999;
}

.name-note {
  font-size: 12px;
  color: #ff6666;
  line-height: 1.4;
  text-align: left;
}

/* 错误提示 */
.error-message {
  background: #fff;
  color: #ff3333;
  padding: 12px 16px;
  margin: 0 16px 20px;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  border: 1px solid #ffebee;
}

/* 提交按钮 */
.submit-button {
  background: #3f9fff;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 16px;
  margin: 0 16px 20px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  width: calc(100% - 32px);
  box-sizing: border-box;
}

.submit-button:hover {
  background: #2e86d9;
}

.submit-button:disabled {
  background: #c0c0c0;
  cursor: not-allowed;
}

.submit-button:disabled:hover {
  background: #c0c0c0;
}

/* PC端键盘显示时，提交按钮底部加间距 */
.cashier-container.keyboard-active .submit-button {
  margin-bottom: 240px; /* 16px + 220px = 236px，约等于240px */
}
</style>